import { render, staticRenderFns } from "./Devis.vue?vue&type=template&id=6f165dc1&"
import script from "./Devis.vue?vue&type=script&lang=js&"
export * from "./Devis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports